const formatPhoneNumber = (number: string) => {
  const strippedNumber = number.replace(/[^0-9]/, '')

  if (strippedNumber.length === 10) {
    return (
      strippedNumber.slice(0, 3) +
      '.' +
      strippedNumber.slice(3, 6) +
      '.' +
      strippedNumber.slice(-4)
    )
  }

  if (strippedNumber.length === 7) {
    return strippedNumber.slice(0, 2) + '.' + strippedNumber.slice(-4)
  }

  return number
}

export { formatPhoneNumber }
